import * as AF from "@/components/form-items/AbstractForm";
import { ModifiableList } from "@/components/form-items/ModifiableList";
import { useTranslation } from "react-i18next";

const SculptureEditionConditionReportTab = () => {
  const { t } = useTranslation();
  return (
    <AF.Col className="gap-6">
      {/* Rapport de condition */}
      <AF.RichText
        name="sculptureEditionRapportCondition"
        label={t("sculpture.edition.rapportCondition")}
        className="min-h-[200px]"
      />

      {/* Auteur du rapport */}
      <ModifiableList
        name="sculptureEditionRapportConditionAuteur"
        listKey="liste-auteur-rapport-condition"
        label={t("sculpture.edition.rapportConditionAuteur")}
      />

      {/* Date du rapport */}
      <AF.Text
        name="sculptureEditionRapportConditionDate"
        label={t("sculpture.edition.rapportConditionDate")}
        className="w-1/3"
      />

      {/* Rapport reçu et archivé */}
      <AF.Checkbox
        name="sculptureEditionRapportConditionRecuArchive"
        label={t("sculpture.edition.rapportConditionRecuArchive")}
      />
    </AF.Col>
  );
};

export default SculptureEditionConditionReportTab;
